import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ReactiveToggle from "../ReactiveToggle.tsx";

const buttonElem = (handleClick: () => void, isPending: boolean) => {
  return (
    <button
      className={`btn rounded-full active:btn-error ${isPending && "btn-error btn-soft"}`}
      onClick={handleClick}
    >
      <IconChevronLeft /> Zurück
    </button>
  );
};
const NavigateBackButton = () => {
  const navigate = useNavigate();
  const navigateBack = () => navigate(-1);

  return (
    <ReactiveToggle transitional={navigateBack}>{buttonElem}</ReactiveToggle>
  );
};
export default NavigateBackButton;
